import { useQuery } from '@tanstack/react-query';
import {
  UserKeys,
  checkIfKeyUploaded,
  getGmailAuditModels,
  getGmailExportDeprecationStatus,
} from '../../../api/users-api';
import GmailExportGrid from './gmail-export-grid';
import GmailExportDeprecationBanner from './gmail-export-deprecation-banner';
import { pagesConfig } from '../../../shared/pages-config';
import { useUserSettings } from '../../../utils/use-user-settings';
import { isFeatureEnabled } from '../../../utils/feature-flags';
import { Messages } from '../../../utils/message-constants';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';

export default function GmailExportPage() {
  const { toolsRoles, changeLogRoles, features } = useUserSettings();
  const deprecationEnabled = isFeatureEnabled(
    'gmailExportDeprecation',
    features
  );

  const {
    data: gmailAuditModels,
    isLoading: gmailAuditLoading,
    isFetching: gmailAuditFetching,
  } = useQuery({
    queryKey: [UserKeys.GmailAuditModels],
    queryFn: () => getGmailAuditModels(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('gmail audit models'),
    },
  });

  const {
    data: gmailExportKey,
    isLoading: gmailExportKeyLoading,
    isFetching: gmailExportKeyFetching,
  } = useQuery({
    queryKey: [UserKeys.GmailExportKey],
    queryFn: () => checkIfKeyUploaded(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('gmail export key'),
    },
  });

  const { data: deprecationStatus } = useQuery({
    queryKey: [UserKeys.GmailExportDeprecationStatus],
    queryFn: () => getGmailExportDeprecationStatus(),
    enabled: deprecationEnabled,
    meta: {
      errorMessage: Messages.Errors.Network.Loading(
        'gmail export deprecation status'
      ),
    },
  });

  const apiUnavailable =
    deprecationEnabled &&
    deprecationStatus != null &&
    !deprecationStatus.emailAuditApiAvailable;

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.importExport.name },
        { label: pagesConfig.gmailExport.name },
      ]}
      bookmarkKey={pagesConfig.gmailExport.value}
    >
      {deprecationEnabled && deprecationStatus != null && (
        <GmailExportDeprecationBanner
          emailAuditApiAvailable={deprecationStatus.emailAuditApiAvailable}
          hasVaultAccess={deprecationStatus.hasVaultAccess}
        />
      )}
      <GmailExportGrid
        gmailAuditModels={gmailAuditModels}
        isLoading={gmailAuditLoading || gmailExportKeyLoading}
        isFetching={gmailAuditFetching || gmailExportKeyFetching}
        toolsRoles={toolsRoles}
        changeLogRoles={changeLogRoles}
        gmailExportKey={gmailExportKey}
        apiUnavailable={apiUnavailable}
      />
    </SimpleBreadcrumbsPage>
  );
}
